import { useIntl } from 'react-intl';

import { DrinksTabLink, DrinksTabLinkText, DrinksTabsWrapper } from './styled';
import { DrinkCategory } from './types';

interface ProductCustomizationDrinksTabsProps {
  categories: DrinkCategory[];
  activeTab: DrinkCategory;
  onTabPress: (tab: DrinkCategory) => void;
}

export const ProductCustomizationDrinksTabs = ({
  categories,
  activeTab,
  onTabPress,
}: ProductCustomizationDrinksTabsProps) => {
  const { formatMessage } = useIntl();
  return (
    <DrinksTabsWrapper testID="product-customization-drinks-tabs">
      {categories.map(category => (
        <DrinksTabLink
          key={`drinks-tab-${category}`}
          onPress={() => onTabPress(category)}
          minWidth={`${100 / categories.length}%`}
          active={activeTab === category}
        >
          <DrinksTabLinkText variant="headerThree" active={activeTab === category}>
            {formatMessage({ id: DrinkCategory[category].toLowerCase() })}
          </DrinksTabLinkText>
        </DrinksTabLink>
      ))}
    </DrinksTabsWrapper>
  );
};
